<div *ngIf="error" class="alert alert-danger">
  <p>{{error}}</p>
  <p class="m-0" i18n="@@support.inCaseYouAreFacingIssues">If you are facing issues in submitting the contact form, please contact us through <a href="mailto:help@bitoasis.net">help@bitoasis.net</a></p>
</div>

<div *ngIf="success" class="alert alert-success">
  <ng-container i18n="@@support.success">Your ticket has been sent successfully</ng-container>
</div>

<form class="form" class="white" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div formGroupName="main">
    <form-field class="front" label="Your Email" i18n-label="@@support.email.label">
      <input type="email" formControlName="email" placeholder="Enter Your Email Address" i18n-placeholder="@@support.email.placeholder">
    </form-field>

    <form-field class="front" label="Ticket Category" i18n-label="@@support.category.label">
      <ng-select [clearable]="false" [items]="categories" formControlName="category" bindLabel="name" bindValue="key" placeholder="Select your ticket type" i18n-placeholder="@@support.category.placeholder"></ng-select>
    </form-field>
  </div>

  <ng-container *ngIf="category.value" [ngSwitch]="category.value">
    <fiat-deposit-ticket *ngSwitchCase="'payment_request'" [form]="form"></fiat-deposit-ticket>
    <phone-change-ticket *ngSwitchCase="'phoneChange'" [form]="form"></phone-change-ticket>
    <bank-details-ticket *ngSwitchCase="'bankDetailsChange'" [form]="form"></bank-details-ticket>
    <citizenship-residency-validation-ticket *ngSwitchCase="'citizenshipResidencyValidation'" [form]="form"></citizenship-residency-validation-ticket>
    <otc-ticket *ngSwitchCase="'otc'" [form]="form"></otc-ticket>
    <general-ticket *ngSwitchDefault="" [form]="form"></general-ticket>
  </ng-container>

  <div class="submit mb-4">
    <button class="btn btn-primary btn-block"[disabled]="loading || !category.value">
      <ng-container *ngIf="loading" i18n="@@support.submitLoading">Loading...</ng-container>
      <ng-container *ngIf="!loading" i18n="@@support.submitButton">Send Support Ticket</ng-container>
    </button>
  </div>
</form>